import React from "react";
import { EventQuery, FeeType } from "~graphql/sdk";
import { Price } from "flicket-ui";
import { getTicketFeeProperties } from "./common.utils";

interface PriceWithFeeProps {
  price: number;
  ticketType: EventQuery["event"]["ticketTypes"][number];
  showFees: boolean;
}

const PriceWithFee = ({
  price,
  ticketType,
  showFees = false,
}: PriceWithFeeProps) => {
  if (!price) return <>Free</>;

  if (ticketType?.soldOut) return <>Sold out</>;

  const { ticketFee, ticketFeeType, stadiumLevyFee } = getTicketFeeProperties(
    ticketType
  );

  if (!showFees || (ticketFee <= 0 && stadiumLevyFee <= 0)) {
    return <Price price={price} />;
  }

  const FeeComponent = ((price: number) => {
    const Component =
      ticketFeeType === FeeType.Percentage ? (
        <Price price={price * (ticketFee / 100) + stadiumLevyFee} />
      ) : (
        <Price price={ticketFee + stadiumLevyFee} />
      );

    return <>{Component} Fees</>;
  })(price);

  return (
    <>
      <Price price={price} /> {"\u002B"} {FeeComponent}
    </>
  );
};

export default PriceWithFee;
